import React, { Component, useState } from "react";
import { NavLink } from "react-router-dom";
import notification from "../../../images/notifications_white.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  actionDeliverySuccessDetails,
  actionProcessingJobs,
} from "../../../actions/index";
import api from "../../../utility/api/api.js";
import { Tabs, Tab } from "react-tab-view";
import { notify } from "react-notify-toast";
import createHistory from "history/createBrowserHistory";
import "./PaymentCashCard.css";
import loader from "../../../images/loader.gif";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
} from "reactstrap";
import PaymentType from "./PaymentType";
import callShippingJobs from "../../../utility/api/callShippingJobs";
import callPartialReturnOrderItem from "../../../utility/api/callPartialReturnOrderItem";
import DelayReasonModal from "../DeliverOrder/DelayReasonModal.js";

var cardamount = "";
var Payment_Type = "";

class PaymentCashCard extends Component {
  constructor(props) {
    super(props);
    const orderData = this.props.orderData;
    this.state = {
      showDelayReasonModal: false,
      paymentValidationError: "",
      selectedDelayReason: null,
      remainingAmount: orderData.amount_to_be_collected,
      cashcardstate: "",
      isLoading: false,
      payments: [],
      cardType: "",
      machineType: "",
      sort_paid: null,
      callShippingJobs: JSON.parse(localStorage.getItem("callShippingJobs")),
      callPartialReturnOrderItem: JSON.parse(localStorage.getItem("callPartialReturnOrderItem"))
    };
    const roundd = this.state.callShippingJobs[0].data.orders.find(order => order.order_id == this.props.orderData.order_id)
    this.state.roundd_amt = roundd.round_off_amt;
    const history = createHistory();
    const unlisten = history.listen((location, action) => { });
    this.card_amount = 0;
    this.cash_amount = 0;
  }
  
  componentDidMount() {
    const roundd = this.state.callShippingJobs[0].data.orders.find(order => order.order_id == this.props.orderData.order_id)
    // const roundOffvalue =
    //   this.state.callPartialReturnOrderItem != null
    //     ? this.state.callPartialReturnOrderItem[0].data.round_off_amt
    //     : roundd.round_off_amt;

    const orderData = this.props.orderData
    this.setState({
      roundd_amt:
        this.state.callPartialReturnOrderItem != null &&
        this.state.callPartialReturnOrderItem[0] &&
        this.state.callPartialReturnOrderItem[0].data
          ? this.state.callPartialReturnOrderItem[0].data.round_off_amt.toFixed(3)
          : roundd.round_off_amt.toFixed(3),
    });
  }
  handleRemove(removedData) {
    console.log("removedData", removedData);
    localStorage.setItem("removedData",JSON.stringify(removedData))
    // const duplicateInRemove = localStorage.getItem("duplicate")
    const itemToRemoveIndex = this.state.payments.findIndex(function (obj) {
      return obj.type == removedData.type && obj.amount == removedData.amount && obj.trnsId == removedData.trnsId && obj.cardType == removedData.cardType && obj.machineType == removedData.machineType;
    });
    console.log("removedData111", itemToRemoveIndex);
    // proceed to remove an item only if it exists.
    if (itemToRemoveIndex !== -1) {
      console.log("going to splice method")
      this.state.payments.splice(itemToRemoveIndex, 1);
    }

    console.log("removedData222", this.state.payments);
    // if(duplicateInRemove){
    //   console.log("going to here")
    //   // localStorage.setItem("duplicateRemove",true)
    // }
    this.setState({
      payments: this.state.payments,
    })
  }
  handleSortPaid(e) {
    if (e.target.value > 0.5) {
      e.target.value = 0
      notify.show("Maximum allowed value is 0.5", "error");
    } else {
      this.setState({ sort_paid: e.target.value })
    }
  }

  handleAmount(e) {

  const statePayments = this.state.payments
  localStorage.setItem("statePayments",JSON.stringify(statePayments))

    const orderData = this.props.orderData;
    let amount = document.getElementById("amountPayment");
    let value = e.target.value;

    const refoundAmnt = orderData.refund_amount
      ? parseFloat(orderData.refund_amount).toFixed(3)
      : 0;
    const collectableAmount = (
      parseFloat(orderData.amount_to_be_collected) - this.state.roundd_amt - refoundAmnt
    ).toFixed(3);
    let totalAmount = this.state.payments.reduce(
      (total, current) => total + parseFloat(current.amount),
      0
    );
    totalAmount = parseFloat(totalAmount.toFixed(3));
    
    if (totalAmount <= collectableAmount) {
      amount.value = parseFloat(collectableAmount - totalAmount).toFixed(3);
    } else if (amount.value === "0.00") {
      e.target.value = "";
    } 

  }

  async getValue(e, selectedReason) {
    e.preventDefault();
    let paymentBody;
    // console.log("paymentBody33", this.state.cardType, paymentBody);

    let totalAmount = this.state.payments.reduce(
      (total, current) => total + parseFloat(current.amount),
      0
    );
    totalAmount = parseFloat(totalAmount).toFixed(3);

    const orderData = this.props.orderData;

    const refoundAmnt = orderData.refund_amount
      ? parseFloat(orderData.refund_amount).toFixed(3)
      : 0;
    const collectableAmount = (
      parseFloat(orderData.amount_to_be_collected) - this.state.roundd_amt - refoundAmnt
    ).toFixed(3);
    console.log("get valuee::;", totalAmount,collectableAmount)
    if (
      (collectableAmount != 0 && totalAmount != collectableAmount ) 
    ) {
      notify.show("Please Enter Valid Amount", "error");
      return;
    }

    if (this.state.payments && this.state.payments.length == 1) {
      this.state.payments.map((data) => {
        if (data.type == "Cash") {
          paymentBody = {
            jobOrderId: this.props.orderData.job_order_id,
            amount_paid: data.amount,
            paymentType: "cash",
            roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
            roundoff_payment_type: "roundoff_payment"
          };
        }
        if (data.type == "On Credit") {
          paymentBody = {
            jobOrderId: this.props.orderData.job_order_id,
            on_credit_type: 'on_credit',
            on_credit_payment: data.amount,
            roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
            roundoff_payment_type: "roundoff_payment"
          };
        }
        if (data.type == "BMMI ALA") {
          paymentBody = {
            jobOrderId: this.props.orderData.job_order_id,
            bmmi_ala_type: 'bmmi_ala',
            bmmi_ala_payment: data.amount,
            roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
            roundoff_payment_type: "roundoff_payment"
          };
        }
        if (data.type == "Short Paid") {
          paymentBody = {
            jobOrderId: this.props.orderData.job_order_id,
            short_paid_typee: "short_paid_payment",
            short_paid_paymentt: data.amount,
            roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
            roundoff_payment_type: "roundoff_payment"
          };
        }
        else if (data.type == "Store Credit") {
          // if (data.amount > this.state.callShippingJobs[0].data.job.store_credit) {
          //   notify.show(`Store credit limit is ${this.state.callShippingJobs[0].data.job.store_credit}`, "error");
          // } else {
            paymentBody = {
              jobOrderId: this.props.orderData.job_order_id,
              store_credit_paid: data.amount,
              store_credit_type: "store_credit_payment",
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }

        // }
        else if (data.type == "Benefit Pay") {
          let transId = document.getElementById("trans_ide").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          }else {
            paymentBody = {
              benefit_pay_payment: data.amount,
              benefit_transaction_id: transId,
              // benefit_card_type: data.cardType,
              jobOrderId: this.props.orderData.job_order_id,
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }
        }
        else if (data.type == "Afs Cards") {
          let transId = document.getElementById("trans_id_afs").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else {
            paymentBody = {
              afs_card_payment: data.amount,
              afs_transaction_id: transId,
              jobOrderId: this.props.orderData.job_order_id,
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }
        }
        else if (data.type == "Card 1") {
          let transId = document.getElementById("trans_id").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            paymentBody = {
              jobOrderId: this.props.orderData.job_order_id,
              amount_paid_card: data.amount,
              transaction_id: transId,
              card_type: data.cardType,
              machine_type: data.machineType,
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }
        }

        else if (data.type == "Card 2") {
          let transId = document.getElementById("trans_id2").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            paymentBody = {
              jobOrderId: this.props.orderData.job_order_id,
              amount_paid_card_2: data.amount,
              transaction_id_2: transId,
              card_type_2: data.cardType,
              machine_type_2: data.machineType,
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }
        }

        else if (data.type == "Card 3") {
          let transId = document.getElementById("trans_id3").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            paymentBody = {
              jobOrderId: this.props.orderData.job_order_id,
              amount_paid_card_3: data.amount,
              transaction_id_3: transId,
              card_type_3: data.cardType,
              machine_type_3: data.machineType,
              roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
              roundoff_payment_type: "roundoff_payment"
            };
          }
        }
      });
    } else {
      console.log("this.state.payments222", this.state.payments);
      let cashPaying, cashType, cardPaying, cardType, machineType, transactionId,cardPaying2, cardType2, machineType2, transactionId2, cardPaying3, cardType3, machineType3, transactionId3,store_credit_paid, store_credit_typee, on_credit_typee, on_credit_paymentt, bmmi_ala_typee, bmmi_ala_paymentt, short_paid_typee, short_paid_paymentt, benefit_pay_paymentt, benefit_transaction_idd, benefit_card_typee, afs_card_paymentt, afs_transaction_idd;
      this.state.payments.map((data) => {
        if (data.type == "Cash") {
          console.log("this.state.payments223", data.amount, data.type);
          cashPaying = data.amount;
          cashType = data.type;
        }
        else if (data.type == "Store Credit") {
          console.log("this.state.payments223 sctore", data.amount, data.type);
          // if (data.amount > this.state.callShippingJobs[0].data.job.store_credit) {
          //   notify.show(`Store credit limit is ${this.state.callShippingJobs[0].data.job.store_credit}`, "error");
          // } else {
            store_credit_typee = "store_credit_payment",
              store_credit_paid = data.amount
          // }
        }
        else if (data.type == "Short Paid") {
          short_paid_typee = "short_paid_payment",
            short_paid_paymentt = data.amount
        }
        else if (data.type == "On Credit") {
          on_credit_paymentt = data.amount;
          on_credit_typee = 'on_credit';
        }
        else if (data.type == "BMMI ALA") {
          bmmi_ala_typee = 'bmmi_ala';
          bmmi_ala_paymentt = data.amount;
        }
        else if (data.type == "Card 1") {
          let transId = document.getElementById("trans_id").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            cardPaying = data.amount;
            cardType = data.cardType;
            machineType = data.machineType;
            transactionId = transId;
            paymentBody;
          }
        } else if (data.type == "Card 2") {
          let transId = document.getElementById("trans_id2").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            cardPaying2 = data.amount;
            cardType2 = data.cardType;
            machineType2 = data.machineType;
            transactionId2 = transId;
            paymentBody;
          }
        }       else if (data.type == "Card 3") {
          let transId = document.getElementById("trans_id3").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else if (data.cardType == "") {
            notify.show("Please Select Card Type", "error");
            paymentBody = {};
          } else if (data.machineType == "") {
            notify.show("Please Select Machine Type", "error");
            paymentBody = {};
          } else {
            cardPaying3 = data.amount;
            cardType3 = data.cardType;
            machineType3 = data.machineType;
            transactionId3 = transId;
            paymentBody;
          }
        } else if (data.type == "Benefit Pay") {
          let transId = document.getElementById("trans_ide").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          }else {
            benefit_pay_paymentt = data.amount;
            // benefit_card_typee = data.cardType;
            benefit_transaction_idd = transId;
            paymentBody;
          }
        } else if (data.type == "Afs Cards") {
          let transId = document.getElementById("trans_id_afs").value;
          if (transId == "") {
            notify.show("Please Enter Transaction Id", "error");
            paymentBody = {};
          } else {
            afs_card_paymentt = data.amount;
            afs_transaction_idd = transId;
            paymentBody;
          }
        }
      });
      if (cashPaying || cashType || cardPaying || transactionId || cardType || machineType ||
        cardPaying2 || transactionId2 || cardType2 || machineType2 ||
        cardPaying3 || transactionId3 || cardType3 || machineType3 ||
        store_credit_typee || this.state.roundd_amt || store_credit_paid || on_credit_typee || on_credit_paymentt || bmmi_ala_paymentt || bmmi_ala_typee || short_paid_typee || short_paid_paymentt || benefit_pay_paymentt || benefit_transaction_idd || benefit_card_typee || afs_card_paymentt || afs_transaction_idd) {
        paymentBody = {
          jobOrderId: this.props.orderData.job_order_id,
          amount_paid: cashPaying ? cashPaying : null,
          paymentType: cashType ? cashType : null,
          amount_paid_card: cardPaying ? cardPaying : null,
          transaction_id: transactionId ? transactionId : null,
          card_type: cardType ? cardType : null,
          machine_type: machineType ? machineType : null,
          amount_paid_card_2: cardPaying2 ? cardPaying2 : null,
          transaction_id_2: transactionId2 ? transactionId2 : null,
          card_type_2: cardType2 ? cardType2 : null,
          machine_type_2: machineType2 ? machineType2 : null,
          amount_paid_card_3: cardPaying3 ? cardPaying3 : null,
          transaction_id_3: transactionId3 ? transactionId3 : null,
          card_type_3: cardType3 ? cardType3 : null,
          machine_type_3: machineType3 ? machineType3 : null,
          store_credit_type: store_credit_typee ? store_credit_typee : null,
          roundoff_payment_paid: this.state.roundd_amt ? this.state.roundd_amt : null,
          roundoff_payment_type: "roundoff_payment",
          store_credit_paid: store_credit_paid,
          on_credit_type: on_credit_typee ? on_credit_typee : null,
          on_credit_payment: on_credit_paymentt ? on_credit_paymentt : null,
          bmmi_ala_payment: bmmi_ala_paymentt ? bmmi_ala_paymentt : null,
          bmmi_ala_type: bmmi_ala_typee ? bmmi_ala_typee : null,
          short_paid_type: short_paid_typee ? short_paid_typee : null,
          short_paid_payment: short_paid_paymentt ? short_paid_paymentt : null,
          benefit_pay_payment: benefit_pay_paymentt ? benefit_pay_paymentt : null,
          // benefit_card_type :  benefit_card_typee?  benefit_card_typee : null,
          benefit_transaction_id: benefit_transaction_idd ? benefit_transaction_idd : null,
          afs_card_payment: afs_card_paymentt ? afs_card_paymentt : null,
          afs_transaction_id: afs_transaction_idd ? afs_transaction_idd : null,
        };
      }
    }
    if (Object.keys(paymentBody).length >= 0) {
      console.log("paymentBody::::", paymentBody);
      this.setState({ isLoading: true });
      const duplicatee = localStorage.getItem("duplicate")
      if(duplicatee){
      notify.show("Payment Type already Exists","error")
      } else {
        if (this.state.delay_time && selectedReason) {
          paymentBody = {
            ...paymentBody,
            delayTripOrder: {
              "jobOrderId": this.props.orderData.job_order_id,
              "reason": selectedReason.reason,
              "time": this.state.delay_time
            }
          }
        }
        await api.riderCashPayment(this, paymentBody);
      }
     
      this.setState({ isLoading: false });
    }
  }

  testCharacter(event) {
    let regex = new RegExp("^[0-9]+$");
    let key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  addPayment = () => {

// localStorage.setItem("paymentsLenght",this.state.payments.length)
//   console.log("this.state.payments in addPayment",this.state.payments)

//     let currentPaymentType = JSON.parse(localStorage.getItem("propsItem"))


//     console.log("currentPaymentType",currentPaymentType)

    // const duplicateValue = allPayments && allPayments.find(p => p.type === currentPaymentType.type)

    // if(duplicateValue && duplicateValue.type !=="" ){
    //   notify.show("This payment type already selected", "error");

    // }else{




    const duplicate = localStorage.getItem("duplicate")
    localStorage.removeItem("removedData")
    localStorage.removeItem("noDup")
    const prevVal = this.state.payments.length - 1
    if (prevVal >= 0 ) {
       if (this.state.payments[prevVal].type === "" && this.state.payments[prevVal].amount === "" ) {
        notify.show("Enter Payment Details", "error");
      }
      else if(this.state.payments[prevVal].type === ""){
        notify.show("Enter Payment Details", "error");
      }
      else if(duplicate){
        notify.show("This payment type already selected", "error");
      }
      else if (this.state.payments[prevVal].type === "Card 1" && this.state.payments[prevVal].amount === "" && this.state.payments[prevVal].trnsId==="" && this.state.payments[prevVal].cardType==="" && this.state.payments[prevVal].machineType == ""||
      this.state.payments[prevVal].type === "Card 1" && this.state.payments[prevVal].amount === "" ||
      this.state.payments[prevVal].type === "Card 1" && this.state.payments[prevVal].trnsId === "" ||
      this.state.payments[prevVal].type === "Card 1" && this.state.payments[prevVal].cardType === "" ||
      this.state.payments[prevVal].type === "Card 1" && this.state.payments[prevVal].machineType === ""
      ) {
        notify.show("Enter Payment Details", "error");
      }
       else if (this.state.payments[prevVal].type === "Card 2" && this.state.payments[prevVal].amount === "" &&
        this.state.payments[prevVal].trnsId === "" && this.state.payments[prevVal].cardType === "" && this.state.payments[prevVal].machineType == "" ||
        this.state.payments[prevVal].type === "Card 2" && this.state.payments[prevVal].amount === "" ||
        this.state.payments[prevVal].type === "Card 2" && this.state.payments[prevVal].trnsId === "" ||
        this.state.payments[prevVal].type === "Card 2" && this.state.payments[prevVal].cardType === "" ||
        this.state.payments[prevVal].type === "Card 2" && this.state.payments[prevVal].machineType === ""
      ) {
        notify.show("Enter Payment Details", "error");
      }
       else if (this.state.payments[prevVal].type === "Card 3" && this.state.payments[prevVal].amount === "" &&
        this.state.payments[prevVal].trnsId === "" && this.state.payments[prevVal].cardType === "" && this.state.payments[prevVal].machineType == "" ||
        this.state.payments[prevVal].type === "Card 3" && this.state.payments[prevVal].amount === "" ||
        this.state.payments[prevVal].type === "Card 3" && this.state.payments[prevVal].trnsId === "" ||
        this.state.payments[prevVal].type === "Card 3" && this.state.payments[prevVal].cardType === "" ||
        this.state.payments[prevVal].type === "Card 3" && this.state.payments[prevVal].machineType === ""
       ) {
        notify.show("Enter Payment Details", "error");
      }
        else if(
           (this.state.payments[prevVal].type ==="Cash" && this.state.payments[prevVal].amount === "") ||
           (this.state.payments[prevVal].type ==="Store Credit" && this.state.payments[prevVal].amount === "") ||
           (this.state.payments[prevVal].type ==="Short Paid" && this.state.payments[prevVal].amount === "") ||
           (this.state.payments[prevVal].type ==="Benefit Pay" && this.state.payments[prevVal].amount === "") ||
           (this.state.payments[prevVal].type ==="Benefit Pay" && this.state.payments[prevVal].trnsId === "") ||
           (this.state.payments[prevVal].type ==="BMMI ALA" && this.state.payments[prevVal].amount === "" )||
         (this.state.payments[prevVal].type === "Afs Cards" && this.state.payments[prevVal].amount === "") ||
         (this.state.payments[prevVal].type === "Afs Cards" && this.state.payments[prevVal].trnsId === "")
        ){
          notify.show("Enter Payment Details", "error");
      }
 
      else {
        if (this.state.payments && this.state.payments.length < this.state.callShippingJobs[0].data.job.payment_types.length) {
          const payments = [
            ...this.state.payments,
            ...[{ type: "", amount: "", trnsId: "", cardType: "", machineType: "" }],
          ];

          this.setState({
            payments,
          });
        }
      }
    } else {
      if (this.state.payments && this.state.payments.length < this.state.callShippingJobs[0].data.job.payment_types.length) {
        const payments = [
          ...this.state.payments,
          ...[{ type: "", amount: "", trnsId: "", cardType: "", machineType: "" }],
        ];

        this.setState({
          payments,
        });
      }
    }
  // }

  };

  handleDelayReasonSubmit = async (e, selectedReasonObj) => {    
    // Retry payment with the selected delay reason
    await this.getValue(e, selectedReasonObj);
    // Close the modal
    this.setState({
      showDelayReasonModal: false,
      selectedDelayReason: selectedReasonObj,
    });
  };

  handleDelayReasonModalClose = () => {
    this.setState({
      showDelayReasonModal: false,
      paymentValidationError: "",
      selectedDelayReason: null
    });
  };

  render() {
    const rounddd = this.state.callShippingJobs[0].data.orders.find(order => order.order_id == this.props.orderData.order_id)
    localStorage.setItem("allPaymentMethods",JSON.stringify(this.state.payments))
    if (this.state.cashcardstate && this.state.cashcardstate == "success") {
      this.props.history.push("/deliverysuccess");
    }
    const orderData = this.props.orderData;

    const returnItemQty = orderData.return_items.length
    const roundOffvalue =
      this.state.callPartialReturnOrderItem != null &&
      this.state.callPartialReturnOrderItem[0] &&
      this.state.callPartialReturnOrderItem[0].data
        ? this.state.callPartialReturnOrderItem[0].data.round_off_amt
        : rounddd.round_off_amt;
    
    const refoundAmnt = orderData.refund_amount
      ? parseFloat(orderData.refund_amount).toFixed(3)
      : 0;
    const collectableAmount = (
      parseFloat(orderData.amount_to_be_collected) -
      roundOffvalue -
      refoundAmnt
    ).toFixed(3);
    if (orderData) {
      return (
        <div className="container mw-100">
          {/* <div className="rider-header position-fixed deliver-custom-header">
            <div className="header-left-side">
              <div>
                <NavLink to="/deliveryorder">
                  <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                </NavLink>{" "}
                <span className="text-white hub-header-title">
                  Payment Collection
                </span>
                <img 
                  className="float-right pt-1"
                  // src={notification}
                  // alt="notification"
                />
              </div>
            </div>
          </div> */}
          <div className="rider-header position-fixed deliver-custom-header">
            <div className="header-left-side">
              <div className="deliverOrderHeader">
                <NavLink to="/deliveryorder">
                  <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                </NavLink>
                <span className="text-white hub-header-title inTransitHeaderTitle">
                  Payment Collection
                </span>
                <img
                  className="float-right pt-1"
                // src={notification}
                // alt="notification"
                />
              </div>
            </div>
          </div>
          <div className="maincontent deliver-order-comp payment_cash_card_container">
            <div className="payment_cash_card_inner p-3">
              {/* <div className="row" style={{justifyContent:"center"}}>
                <div className="col-md-8 col-xs-12">
                  <div className="row" style={{justifyContent:"space-evenly"}}>
                    <div className="col-md-4">Store Credit  </div>
                    <div className="col-md-4">{this.state.callShippingJobs[0].data.job.store_credit.toFixed(3) }</div>
                  </div>
                  <div className="row" style={{justifyContent:"space-evenly"}}>
                    <div className="col-md-4"><b>Amount to be collect</b></div>
                    <div className="col-md-4"><b>{orderData.amount_to_be_collected}</b></div>
                  </div>
                  <div className="row" style={{justifyContent:"space-evenly"}}>
                    <div className="col-md-4">Round Off  </div>
                    <div className="col-md-4">{this.state.roundd_amt}</div>
                  </div>
                </div>
              </div> */}
              <Row style={{ justifyContent: "center" }}>
                <Col md="12" xs="10">
                  <Row style={{ justifyContent: "space-evenly" }}>
                    <Col md="3" xs="6">Store Credit  </Col>
                    <Col md="3" xs="6">{this.state.callShippingJobs[0] && this.state.callShippingJobs[0].data && this.state.callShippingJobs[0].data.job && this.state.callShippingJobs[0].data.job.store_credit && this.state.callShippingJobs[0].data.job.store_credit.toFixed(3)}</Col>
                  </Row>
                  <Row style={{ justifyContent: "space-evenly" }}>
                    <Col md="3" xs="6"><b>Amount to be collect</b> </Col>
                    <Col md="3" xs="6"><b>{orderData.amount_to_be_collected}</b></Col>
                  </Row>
                  <Row style={{ justifyContent: "space-evenly" }}>
                    <Col md="3" xs="6">Round Off  </Col>
                    <Col md="3" xs="6">{this.state.roundd_amt}</Col>
                  </Row>

                </Col>
              </Row>

              <hr />
              <Row style={{ justifyContent: "center" }}>
                <Col md="12" xs="10">
                  <Row style={{ justifyContent: "space-evenly" }}>
                    <Col md="3" xs="8"><b style={{ fontSize: "1.2rem" }}>Remaining Amount</b> </Col>
                    <Col md="3" xs="4">
                      <input
                        min="0"
                        id="amountPayment"
                        type="number"
                        readOnly
                        defaultValue={collectableAmount}
                      /></Col>
                  </Row>
                </Col>
              </Row>

              <div className="plusBtnContainer">
                <div className="plusBtn" onClick={() => this.addPayment()}>
                  +
                </div>
              </div>

              {this.state.payments.map((payment, i) => {
                return (
                  <PaymentType
                    key={i}
                    payment={payment}
                    onTypeSelect={(type) => {
                      payment.type = type;
                    }}
                    handleAmount={(e) => this.handleAmount(e)}
                    handleSortPaid={(e) => this.handleSortPaid(e)}
                    removePaymentCard={(e) => this.handleRemove(e)}
                  ></PaymentType>
                );
              })}

              <div className="sodexo_btn_container">
                {this.state.isLoading ? (
                  <img src={loader} height="50px" />
                ) : (
                  <button
                    className="mt-3 sodexo_continue_btn"
                    onClick={(e) => this.getValue(e)}
                  >
                    Continue
                  </button>
                )}
              </div>
            </div>
          </div>
          <DelayReasonModal
            delay_time={this.state.delay_time}
            isOpen={this.state.showDelayReasonModal}
            onClose={this.handleDelayReasonModalClose}
            errorMsg={this.state.paymentValidationError}
            onReasonSubmit={this.handleDelayReasonSubmit}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  return {
    orderData: state.orderDetails,
    deliveredDetails: state.deliveryDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionDeliverySuccessDetails: actionDeliverySuccessDetails,
      actionProcessingJobs: actionProcessingJobs,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCashCard);


// WEBPACK FOOTER //
// ./src/components/Intransit/Payment/PaymentCashCard.js